import React from 'react'
import { useTranslation } from 'react-i18next'

function PbmAcdDetails ({ item }) {
  const { t } = useTranslation()
  const SectionCard = ({ title, children }) => (
    <div className='bg-white rounded-md shadow-sm border border-gray-200 p-2 hover:shadow-md transition-shadow'>
      <h2 className='text-sm font-semibold !text-primary border-b pb-1'>
        {title}
      </h2>
      <div className='space-y-1 mt-1'>{children}</div>
    </div>
  )

  const Field = ({ label, value }) => (
    <div className='flex flex-col'>
      <label className='text-xs font-medium text-gray-500'>{label}</label>
      <span className='text-sm text-gray-700 font-medium break-words'>
        {value || <span className='text-gray-400'>---</span>}
      </span>
    </div>
  )

  return (
    <div className='p-3 bg-gray-50 rounded-lg'>
      <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3'>
        <SectionCard title={t('Diagnoses')}>
          <Field label={t('ICD Code')} value={item?.Diagnoses?.icd_code?.[0]} />
          <Field
            label={t('ICD Description')}
            value={item?.Diagnoses?.icd_description?.[0]}
          />
        </SectionCard>

        <SectionCard title={t('Indications')}>
          <Field
            label={t('Indication')}
            value={item?.Indications?.indication?.[0]}
          />
        </SectionCard>

        <SectionCard title={t('Insurance Notes')}>
          <Field
            label={t('Notes 1')}
            value={item?.Insurance_Notes?.insurance_notes1?.[0]}
          />
          <Field
            label={t('Notes 2')}
            value={item?.Insurance_Notes?.insurance_notes2?.[0]}
          />
        </SectionCard>

        <SectionCard title={t('Treatment Plan')}>
          <Field
            label={t('Plan Details')}
            value={item?.Treatment_Plan?.treatment_plan?.[0]}
          />
        </SectionCard>

        {/* <SectionCard title="Coverage Status">
          <Field
            label="Not Covered"
            value={item?.Not_Covered?.not_covered?.[0]}
          />
        </SectionCard> */}

        <SectionCard title={t('Procedures/Operations')}>
          <Field
            label={t('Procedures')}
            value={item?.Procedures_Operations?.procedures?.[0]}
          />
        </SectionCard>
      </div>

      {/* Services Table */}
      <div className='mt-4 bg-white rounded-md shadow-sm border border-gray-200 p-2'>
        <h2 className='text-sm font-semibold !text-primary border-b pb-1'>
          {t('Services')}
        </h2>
        <div className='overflow-x-auto'>
          <table className='w-full text-xs text-left text-gray-700'>
            <thead className='bg-gray-100 !text-primary uppercase'>
              <tr>
                <th className='px-2 py-1'>{t('Code')}</th>
                <th className='px-2 py-1'>{t('Type')}</th>
                <th className='px-2 py-1'>{t('Description')}</th>
                <th className='px-2 py-1'>{t('Coverage Status')}</th>
              </tr>
            </thead>
            <tbody>
              {item?.Services?.length > 0 ? (
                item?.Services.map((service, index) => (
                  <tr key={index} className='border-b hover:bg-gray-50'>
                    <td className='px-2 py-1'>{service?.service_code}</td>
                    <td className='px-2 py-1'>{service?.service_type}</td>
                    <td className='px-2 py-1'>
                      {service?.service_description}
                    </td>
                    <td className='px-2 py-1'>{service?.not_covered}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan='3'
                    className='px-2 py-2 text-center text-gray-400'
                  >
                    {t('No services available')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default PbmAcdDetails
